import bitgetWalletIcon from '@ui/assets/bitget-wallet.svg';
import googleIcon from '@ui/assets/google.svg';
import metamaskIcon from '@ui/assets/metamask.svg';
import okxWalletIcon from '@ui/assets/okx-wallet.svg';
import { isProdEnv } from '@ui/constants/env';
import { getUrlSearchParam } from '@ui/utils/urlSearchParam';

export type ConnectorId =
  | 'io.metamask'
  | 'walletConnect'
  | 'mock'
  | 'bitget'
  | 'com.brave.wallet'
  | 'com.okex.wallet'
  | 'io.privy.wallet';

export type WhitelistedConnector = {
  id: ConnectorId;
  name: string;
  icon: string;
  getDownloadLink: (isMobile?: boolean) => string;
};

const getMockConnector = (): WhitelistedConnector[] => {
  if (!global.window || isProdEnv) return [];
  const query = getUrlSearchParam();
  const shouldShowMockConnector =
    query?.has('isDebug') && query?.get('mockAccount');

  if (shouldShowMockConnector) {
    return [
      {
        id: 'mock',
        name: 'Mock Wallet',
        icon: '/favicon-32x32.png',
        getDownloadLink() {
          return window.location.href;
        },
      },
    ];
  }

  return [];
};

export const whitelistedConnectors: WhitelistedConnector[] = [
  // ...getMockConnector(),
  {
    id: 'io.metamask',
    name: 'MetaMask',
    icon: metamaskIcon.src,
    getDownloadLink: () => {
      return `https://metamask.app.link/dapp/${window.location.host}${window.location.pathname}`;
    },
  },
  // {
  //   name: 'WalletConnect',
  //   id: 'walletConnect',
  //   icon: walletConnectIcon.src,
  //   getDownloadLink: () => 'https://reown.com/',
  // },
  {
    name: 'OKX Wallet',
    id: 'com.okex.wallet',
    icon: okxWalletIcon.src,
    getDownloadLink: () =>
      `https://www.okx.com/download?deeplink=${encodeURIComponent(
        `okx://wallet/dapp/url?dappUrl=${encodeURIComponent(
          window.location.href,
        )}`,
      )}`,
  },
  {
    name: 'BitGet Wallet',
    id: 'bitget',
    icon: bitgetWalletIcon.src,
    getDownloadLink: (isMobile?: boolean) => {
      if (isMobile) {
        return `https://bkcode.vip?action=dapp&url=${encodeURIComponent(
          window.location.href,
        )}`;
      }
      
return 'https://web3.bitget.com/en/wallet-download?type=1';
    },
  },
  {
    name: 'Google',
    id: 'io.privy.wallet', // only google available in our privy way
    icon: googleIcon.src,
    getDownloadLink: (_isMobile?: boolean) => ''
  },
];


export const polyfillConnectors: WhitelistedConnector[] = [
  {
    name: 'Google',
    id: 'io.privy.wallet', // only google available in our privy way
    icon: googleIcon.src,
    getDownloadLink: (_isMobile?: boolean) => ''
  },
];


export const connectorConfigMap = Object.fromEntries(
  whitelistedConnectors.map((v): [ConnectorId, WhitelistedConnector] => [
    v.id,
    v,
  ]),
) as Record<ConnectorId, WhitelistedConnector>;
